import type { Facet, ChartType } from '~/state/useChartKnobsState'

export interface FacetOption {
  value: Facet
  label: string
  isStacked: boolean
  isBar: boolean
}

export const FACET_OPTIONS: Record<Facet, FacetOption> = {
  line: { value: 'line', label: 'Line', isStacked: false, isBar: false },
  stacked_area: { value: 'stacked_area', label: 'Stacked Area', isStacked: true, isBar: false },
  bar: { value: 'bar', label: 'Bar', isStacked: false, isBar: true },
  stacked_bar: { value: 'stacked_bar', label: 'Stacked Bar', isStacked: true, isBar: true },
}

export function availableFacetsForChartType(chartType: ChartType): Facet[] {
  if (chartType === 'absolute_bar') return ['bar', 'stacked_bar']
  if (chartType === 'wrapper') return ['bar']
  return ['line', 'stacked_area', 'bar', 'stacked_bar']
}

/** Display-time downgrade (spec §7 pins): a stacked facet requested by URL/pin state on a
 *  non-additive selection renders as its non-stacked sibling. State is NOT rewritten. */
export function downgradeFacet(facet: Facet, additive: boolean): Facet {
  if (additive) return facet
  if (facet === 'stacked_bar') return 'bar'
  if (facet === 'stacked_area') return 'line'
  return facet
}
